/* eslint-disable new-cap */
import React from 'react';
import I18n from 'i18n-js';
import { RCMenu, RCModal } from '@reverbdotcom/cadence/components';
import AffirmZeroPercentPopoverContent from './AffirmZeroPercentPopoverContent';
import { trackEvent, MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import SellerListingsCollectionContext from '../../SellerListingsCollectionContext';
import SellerListingCardContext from '../../SellerListingCardContext';
import { ActionType } from '../../sellerListingCardReducer';

export const NOT_ELIGIBLE = 'not_eligible';
export const ALREADY_ENABLED = 'already_enabled';
export const FAILED_TO_CREATE = 'failed_to_create';
export const NOT_IN_ZERO_PERCENT = 'not_in_zero_percent';
export const FAILED_TO_DELETE = 'failed_to_delete';

interface IExternalProps {
  listingId: string;
  isAffirmEnabled: boolean;
  setShowModal: (isModalOpen) => void;
}

function toastErrorMessage(errorType) {
  switch (errorType) {
    case NOT_ELIGIBLE:
      return I18n.t('discovery.listingsManagement.toast.message.enable.notEligible');
    case ALREADY_ENABLED:
      return I18n.t('discovery.listingsManagement.toast.message.enable.alreadyEnabled');
    case FAILED_TO_CREATE:
      return I18n.t('discovery.listingsManagement.toast.message.enable.failedToEnable');
    case NOT_IN_ZERO_PERCENT:
      return I18n.t('discovery.listingsManagement.toast.message.disable.notInZeroPercent');
    case FAILED_TO_DELETE:
      return I18n.t('discovery.listingsManagement.toast.message.disable.failedToDisable');
    default:
      return I18n.t('discovery.listingsManagement.genericError');
  }
}

export function AffirmZeroPercentButton({
  listingId,
  isAffirmEnabled,
  setShowModal,
}: IExternalProps) {
  const buttonText = isAffirmEnabled ? I18n.t('discovery.listingsManagement.sellerListingCard.affirmZeroPercent.disableButtonText') : I18n.t('discovery.listingsManagement.sellerListingCard.affirmZeroPercent.enableButtonText');

  return (
    <RCMenu.Item
      onClick={() => {
        setShowModal(true);
        trackEvent({
          componentName: 'AffirmZeroPercentButton',
          eventName: MParticleEventName.ClickedAffirmZeroPercentFinancingButton,
          listingId: listingId,
        });
      }
      }
    >
      {buttonText}
    </RCMenu.Item>
  );
}

export function AffirmZeroPercentModal({
  showModal,
  setShowModal,
  isAffirmEnabled,
  listingId,
}) {
  const { useLazySellerListingsQuery } = React.useContext(SellerListingsCollectionContext);
  const { refetchSellerListings } = useLazySellerListingsQuery();

  const { dispatch } = React.useContext(
    SellerListingCardContext,
  );

  return (
    <RCModal
      isOpen={showModal}
      title={{ 'aria-labelledby': 'Affirm Zero Percent Modal' }}
      onOpenChange={(state) => {
        if (!state) setShowModal(false);
      }}
    >
      <AffirmZeroPercentPopoverContent
        isAffirmEnabled={isAffirmEnabled}
        listingId={listingId}
        onSuccessCallback={() => {
          refetchSellerListings([listingId]);
          setShowModal(false);
          dispatch({
            type: ActionType.SHOW_TOAST,
            payload: {
              isSuccess: true,
              message: I18n.t('discovery.listingsManagement.toast.message.success'),
            },
          });
        }}
        onFailureCallback={(errorType) => {
          refetchSellerListings([listingId]);
          dispatch({
            type: ActionType.SHOW_TOAST,
            payload: {
              isSuccess: false,
              message: toastErrorMessage(errorType),
            },
          });
        }}
      />
    </RCModal>
  );
}
